import { getBanks } from '@/services/banks.service';

const Model = {
  namespace: 'banks',
  state: [],

  effects: {
    *fetch(_, { call, put }) {
      const response = yield call(getBanks);
      yield put({
        type: 'setBanks',
        payload: response.data,
      });
    },
  },
  reducers: {
    setBanks(state, action) {
      return action.payload;
    },
  },
};
export default Model;
